/**
 * an event log entry is created for the following actions:
 * 1. answered correctly (actionType = "answered-correctly")
 * 2. answered incorrectly (actionType = "answered-incorrectly")
 * 3. requested clue (actionType = "requested-clue")
 * 4. renamed team (actionType = ""team-renamed")
 * these events are loaded on page load, and then updated via WebSockets over MQTT
 */
import { hashCode } from '../utils/string.utils';
import { CluePenalty } from './JamTeamChallengeAnswer';

export type EventLogActionType =
  | 'completed-task'
  | 'completed-challenge'
  | 'answered-incorrectly'
  | 'requested-clue'
  | 'team-renamed'
  | 'started-challenge'
  | 'used-aws-cli'
  | 'used-aws-console'
  | 'used-code-whisperer';

export class JamEventLogEntry {
  actionType: EventLogActionType;
  challengeDifficulty: number;
  challengeId: string;
  taskId: string;
  taskNumber: number;
  challengeScore: number;
  pointsEarned: number;
  cluePenalties: CluePenalty[] = [];
  dateTimeUTC: number;
  eventName: string;
  teamName: string;
  teamDisplayName?: string;
  newTeamDisplayName?: string;

  static fromPlainObject(obj: any): JamEventLogEntry {
    const entry: JamEventLogEntry = Object.assign(new JamEventLogEntry(), obj);
    entry.cluePenalties = (entry.cluePenalties || []).map(CluePenalty.fromPlainObject);
    return entry;
  }

  get score(): number {
    let score: number = this.pointsEarned || 0;
    if (this.cluePenalties) {
      this.cluePenalties.forEach((cluePenalty) => {
        if (cluePenalty.refunded) return;
        score -= cluePenalty.penalty || 0;
      });
    }
    return Math.max(0, score);
  }

  get hash(): number {
    return hashCode(JSON.stringify(this)) + hashCode(this.teamName) + this.dateTimeUTC;
  }
}
